export const NavPaths = {
    home: "/",
    randomPath: "/50f5c51a-b82d-11ed-afa1-0242ac120002",
    dashboard: "/dashboard",
    faq: "/faq",
    orderbook: "/orderbook",
    portfolio: "/portfolio",
    "fund-details": "/fund-details",
    discover: "/discover",
    chain: "/option-chain",
    openInterest: {
        index: "/open-interest",
        oiDashboard: "/open-interest",
        multiStrikeOI: "/open-interest/multi-strike",
        combineOI: "/open-interest/combine-oi",
        maxPain: "/open-interest/max-pain",
    },
    stockInfo: "/stock-info",
    ideas: {
        index: "/ideas",
        Basket: "/ideas/basket",
        Equity: "/ideas/derivatives",
        Commodity: "/ideas/commodity",
    },
    fiiDii: "/fii-dii",
    fnoStats: {
        index: "/fno-stats",
        futActivity: "/fno-stats/futactivity",
        futScreener: "/fno-stats/stock-screener",
        optActivity: "/fno-stats/opt-activity",
        optScreener: "/fno-stats/optscreener",
        heatmap: "/fno-stats/stock-heatmap",
        banlist: "/fno-stats/banlist",
        futIntraDayBuilup: "/fno-stats/fut-intra-build-up",
        indexContributors: "/fno-stats/index-contributors",
        sectors: "/fno-stats/sectors",
        indiavixVsIndices: "/fno-stats/vix-vs-indices",
    },
    strategies: "/strategies",
    predefined: "/predefined",
    momentum: "/momentum-stocks",
    SmartStrategies: "/smart",
    SmartOptionStrategies: "/strategies/smart",
    Scalping: "/scalping",
    TradeTron: "/strategies/tradetron",
    StrategyReport: "/strategies/strategy-pl",
    Positions: "/positions",
    Orders: "/orders",
    Vtt: "/vtt",
    Baskets: "/basket",
    Chart: "/tradingviewchart",
    Cdslsuccess: "/holdingsCdslSuccess",
    Cdslfailure: "/holdingsCdslFailure",
    StraddleChart: "/multi-straddle-strangle-chart",
    chainExpanded: "/option-chain-expanded",
    orderbookExpanded: "/orderbook-expanded",
    positionExpanded: "/position-expanded",
    optionChainIframe: "/oc-iframe",
};
